import noScroll from "@/utils/noScroll.js";
import clearForm from "@/utils/clearForm.js";

export default function (element, data) {   
    const eventName = data.event;
    window.addEventListener(eventName, function (event) {
        open(event.detail || {});
    });

    window.addEventListener("closePopupForm", function () {
        close();
    });

    element.addEventListener("click", function (event) {
        if (event.target == element) {
            close();
        }
    });

    element.querySelector(".close").addEventListener("click", function () {
        close();
    });

    function open(detail) {
        element.querySelectorAll(".details-field").forEach(element => {
            element.value = "";
        });

        for (const [key, value] of Object.entries(detail)) {
            element.querySelector(".details-field[name='" + key + "']").value = value;
        }
        
        element.classList.add("open");
        noScroll.hideScroll();
    }

    function close() {
        element.classList.remove("open");
        noScroll.showScroll();

        clearForm(element.querySelector(".popup-form"));
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary